module.exports = __webpack_public_path__ + "img/element_to_constellation.9759e306.svg";